import { CopyIcon } from "lucide-react";

import { Button } from "@/components/ui/button";

import { useSuccessToast } from "@/hooks/useSuccessToast";
import { misc } from "@/lib/misc";
import { getScreenFromPathname, mixpanelUtils } from "@/lib/mixpanel/mixpanel";

export const CopyButton = ({ toCopy }: { toCopy: string }) => {
  const successToast = useSuccessToast();

  return (
    <Button
      className="h-auto w-auto p-0 hover:bg-transparent"
      onClick={() => {
        mixpanelUtils.trackButtonClick(
          "Copy to clipboard",
          getScreenFromPathname(location.pathname),
        );
        const formattedText = misc.formatPhoneNumberOnCopy(toCopy);
        void navigator.clipboard.writeText(formattedText);
        successToast({ description: "Copied to clipboard!" });
      }}
      size="icon"
      variant="ghost"
    >
      <CopyIcon className="h-4 w-4 text-slate-500" />
    </Button>
  );
};
